import useApp from '../models/useApp'
import useNetwork from '../models/useNetwork'
import useNode from '../models/useNode'

// Should this account be offered onboarding? A pure signal, safe to read from any
// route — AppLayout owns the redirect that acts on it.
export default function useOnboard() {
  const { networks } = useNetwork()
  const { nodes } = useNode()
  const { ready } = useApp()

  return ready && networks.length <= 1 && nodes.length === 0
}
